import { Traveller } from '../charter.types';

export const formatTravellerName = (traveller: Traveller) => `${traveller.firstName} ${traveller.lastName}`;
